export default "/_next/static/images/fb/logo-noclaim-fb83f617525f89826e6e304c630f8f33.svg";